import { createTheme } from '@mui/material/styles';

// Follows the viewer's OS setting rather than hardcoding a mode, so the
// scaffold looks deliberate in both. Replace with a real palette when the
// product has a visual identity.
export const theme = createTheme({
  colorSchemes: { light: true, dark: true },
  cssVariables: { colorSchemeSelector: 'media' },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily:
      'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    h3: { fontWeight: 700, letterSpacing: '-0.02em' },
  },
});
